import React from "react";
import { queryCache } from "react-query";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import { Theme } from "@material-ui/core";
import OverflowTooltip from "../../../components/OverflowTooltip/OverflowTooltip";
import { ActionBar } from "../../../components/ActionBar/ActionBar";
import LabeledContent from "../../../components/LabeledContent";
import { useWizard } from "../../wizard/context";
import { IBranch } from "../../school/types";
import { useEditBranchConfig } from "../modals/edit/config";
import { getName } from "country-list";
import { QUERY_KEYS } from "../../../constants";

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    padding: theme.spacing(1),
    [theme.breakpoints.down("xs")]: {
      borderBottom: "1px solid #dfdcd6",
    },
  },
  container: {
    marginTop: "-12px",
    marginBottom: "-12px",
    marginLeft: "-8px",
  },
  buttonsContainer: {
    display: "flex",
    textAlign: "center",
    justifyContent: "space-between",
    alignSelf: "center",
  },
  paper: {
    padding: 25,
  },
}));
export default function BranchListItem({ branch }: { branch: IBranch }) {
  const classes = useStyles();

  const { openWizard } = useWizard();
  const getEditConfig = useEditBranchConfig(branch);

  const { userAvailableBranches, branches } = QUERY_KEYS;

  const editBranch = async () => {
    if (await openWizard(getEditConfig)) {
      await queryCache.invalidateQueries([userAvailableBranches]);
      await queryCache.invalidateQueries(branches);
    }
  };

  return (
    <Grid item xs={12} style={{ paddingBottom: 4 }}>
      <Paper className={classes.paper}>
        <Grid
          container
          spacing={2}
          justify={"space-between"}
          alignItems={"flex-start"}
        >
          <Grid item xs={12} sm={11}>
            <Grid container spacing={2} className={classes.container}>
              <Grid item xs={12} sm={6} md={2} className={classes.content}>
                <LabeledContent label={"Country"}>
                  {branch.country ? getName(branch.country as string) : "N/A"}
                </LabeledContent>
              </Grid>
              <Grid item xs={12} sm={6} md={2} className={classes.content}>
                <LabeledContent label={"State"}>
                  <OverflowTooltip text={branch.state} />
                </LabeledContent>
              </Grid>
              <Grid item xs={12} sm={6} md={2} className={classes.content}>
                <LabeledContent label={"City"}>
                  <OverflowTooltip text={branch.city} />
                </LabeledContent>
              </Grid>
              <Grid item xs={12} sm={6} md={5} className={classes.content}>
                <LabeledContent label={"Address"}>
                  <OverflowTooltip text={branch.address} />
                </LabeledContent>
              </Grid>
              <Grid item xs={12} sm={6} md={1} className={classes.content}>
                <LabeledContent label={"Zip Code"}>{branch.zip}</LabeledContent>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={"auto"}
            className={classes.buttonsContainer}
          >
            <div>
              <ActionBar
                editCallBack={editBranch}
                editTooltip={"Edit branch"}
              />
            </div>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
}
